<template>
  <div style="position:relative;padding-top:3px;">
    <transition @enter="enter" @leave="leave">
      <ul class="list" v-show="isShow"><slot></slot></ul>
    </transition>
  </div>
</template>
<script>
import Velocity from 'velocity-animate'
// eslint-disable-next-line
import VelocityUI from 'velocity-animate/velocity.ui'
export default {
  name: 'XDropdownMenu',
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    enter (el, done) {
      Velocity(el, 'transition.slideDownIn', { duration: 300, complete: done })
    },
    leave (el, done) {
      Velocity(el, 'transition.slideUpOut', { duration: 300, delay: 100, complete: done })
    }
  }
}
</script>
<style scoped>
  .list{
    position: absolute;
    top:100%;
    left:0;
    width: 100%;
    border-radius: 4px;
    box-shadow: 0 1px 6px rgba(0,0,0,.2);
    background-color: #fff;
    z-index: 2000;
    padding: 6px 0;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/xdropdown/XDropdownMenu.vue